export const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
export const FETCH_INTAKEBOOK_DATE_CONFIG = "FETCH_INTAKEBOOK_DATE_CONFIG";
export const SET_INTAKEBOOK_SELECTED_DATE = "SET_INTAKEBOOK_SELECTED_DATE";
export const INTAKEBOOK_SELECTED_DATE_CHANGED = "INTAKEBOOK_SELECTED_DATE_CHANGED";
export const FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS = "FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS";
export const DISPLAY_ERROR_MESSAGE = "DISPLAY_ERROR_MESSAGE";
export const RESET_MODEL_AND_ERROR_FLAGS = "RESET_MODEL_AND_ERROR_FLAGS";
export const SHOW_HIDE_LOADER = "SHOW_HIDE_LOADER";
export const SET_SHOW_INSTRUCTION_MODEL = "SET_SHOW_INSTRUCTION_MODEL";
export const INTAKEBOOK_DATE_CHANGE_FLAG = "INTAKEBOOK_DATE_CHANGE_FLAG";
export const UPDATE_MONTHLY_INTAKE = "UPDATE_MONTHLY_INTAKE";
export const TOGGLE_UPLOAD_FILE_MODEL = "TOGGLE_UPLOAD_FILE_MODEL";
export const CANCEL_CHANGE_REQUEST = "CANCEL_CHANGE_REQUEST";
export const SET_CHANGE_REQUEST_DATA = "SET_CHANGE_REQUEST_DATA";
export const SUBMIT_CHANGE_REQUEST = "SUBMIT_CHANGE_REQUEST";
export const SET_CHANGE_REQUEST_NUMBER = "SET_CHANGE_REQUEST_NUMBER";
export const UPDATE_SELECTED_CHECKBOX = "UPDATE_SELECTED_CHECKBOX";
export const SUBMIT_SELECTED_INTAKE_BOOK_SUCCESS = "SUBMIT_SELECTED_INTAKE_BOOK_SUCCESS";
export const SUBMIT_SELECTED_INTAKE_BOOK_FAILED = "SUBMIT_SELECTED_INTAKE_BOOK_FAILED";
export const SET_SELECTEDINTAKEBOOK_DATA_REQUEST = "SET_SELECTEDINTAKEBOOK_DATA_REQUEST";
export const SET_SELECT_UNBLOCK_REQUEST_INTAKEBOOK = "SET_SELECT_UNBLOCK_REQUEST_INTAKEBOOK";
export const SET_SELECTEDINTAKEBOOK_DATA = "SET_SELECTEDINTAKEBOOK_DATA";
export const SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE = "SET_UNBLOCK_FROM_DATE_AND_CONTRACT_CODE";
export const TOGGLE_MONTHLY_UNBLOCK_REQUEST_MODEL = "TOGGLE_MONTHLY_UNBLOCK_REQUEST_MODEL";
export const SUBMIT_MONTHLY_UNBLOCK_REQUEST = "SUBMIT_MONTHLY_UNBLOCK_REQUEST";
export const MONTHLY_UNBLOCK_REQUEST_NOT_ALLOWED = "MONTHLY_UNBLOCK_REQUEST_NOT_ALLOWED";

